import React, { useState, useEffect } from "react";
import {
    BrowserRouter as Router, Link, NavLink, useLocation
} from "react-router-dom";
import axios from "axios";
import MenuNavbar from '../../../MenuNavbar';
import Floaticons from '../../../Floaticons';
import "../TabContentStyles.css";
import baseUrl from "../../../../utils/Constants";
import { Breadcrumbs } from "@material-ui/core";
import CRRAccordian from "./C-Suite-CyberAdvisory/CSuiteAccordian";
import SSAccordian from "./SecurityStrategy-Organization/SSAccordian";



//import CyberPhysicalSecuritydata from '../../../Data/SecuritySpecializationAcademy/CyberPhysicalSecuritydata.json';

function CyberStrategyTab() {
    const location = useLocation();
    const propsData = location.state ? location.state.tabID : null;
    const [displaySkill, setDisplaySkill] = useState('CyberRisk');
    const [crrAc, setcrrAc] = useState([]);
    const [ssAc, setssAc] = useState([]);

    const getCyberStrategy = async () => {

     const response = await axios.get(`${baseUrl}/cyberstrategy`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token")
      }
    }
    ).then(res => {
      console.log("getall", res);
      if(res.data.result.length > 0){

        const arr = res.data.result;
        setcrrAc(arr.filter((item) => item.sub_practice.includes("Regulatory")));
        setssAc(arr.filter((item) => item.sub_practice.includes("Organization")));
      }
      // setAllbooks(res.data.result);
      
      return res.data
    }).catch(err => {console.log("error")});

  }

    useEffect(() => {
        getCyberStrategy();
        console.log("ssac", ssAc);
        console.log("crrac", crrAc);
        
    }, [])
    

    return (
        <><div className="banner-container">
            <img src="images/Banner1.png" alt="banner" className="banner-img" />
            <MenuNavbar />
        </div>
            <Floaticons />
            <div className="TabPanelWrapper">
                <div className="SSA-breadcrumbLinks">
                    <Breadcrumbs separator="/" aria-label="breadcrumb">
                        <NavLink className="menu_title" to="/SecuritySpecializationAcademyNew">
                            <img src="images/SSA/Backbutton.png" class="breadcrumbBack" />
                            Cyber Strategy
                        </NavLink>
                        {displaySkill === "CyberRisk" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberStrategyNew#CyberRisk"
                            >
                                Cyber Risk & Regulatory
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "SecurityStrategy" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberStrategyNew#SecurityStrategy"
                            >
                                Security Strategy & Organization
                            </NavLink>
                        ) : (
                            ""
                        )}
                    </Breadcrumbs>
                </div>
                <div className="tabNavMenu">
                    <a
                        className={
                            displaySkill === "CyberRisk" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("CyberRisk");
                        }}
                        href="#CyberRisk"
                    >
                        <span>Cyber Risk & Regulatory</span>
                    </a>
                    <a
                        className={
                            displaySkill === "SecurityStrategy" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("SecurityStrategy");
                        }}
                        href="#SecurityStrategy"
                    >
                        <span>Security Strategy & Organization</span>
                    </a>
                </div>
                <div className="TabPanel-Wrap">
                    {displaySkill === "CyberRisk" ? (
                        <CRRAccordian crrAc = {crrAc}/>
                    ) : (
                        ""
                    )}
                    {displaySkill === "SecurityStrategy" ? (
                        <SSAccordian ssAc = {ssAc}/>
                    ) : (
                        ""
                    )}
                </div>
            </div>
        </>
    );
}

export default CyberStrategyTab;